<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconArrowRight_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="m19.589 11.426-6.132-6.131a.814.814 0 0 0-1.302.936l2.246 4.52H5.75a1.249 1.249 0 1 0 0 2.499h8.651l-2.246 4.52a.813.813 0 0 0 1.302.936l6.132-6.131a.813.813 0 0 0 0-1.149Z"
    />
</svg>
